<template>
    <div :class="preCls + 'content-box'">
        <!-- 筛选区域 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                v-model="filter.orgLevel"
                style="width: 150px; margin-right: 20px"
                placeholder="层级"
                clearable
                @on-change="search"
            >
                <Option
                    v-for="item in dict.orgLevel.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 日期区间 -->
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <!-- 表格工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入标题搜索"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onAdd"
            >
                新增
            </Button>
            <Button
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <!-- 列表 -->
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template #publishStatus="{ row }">
                <i-switch
                    v-model="row.publishStatus"
                    true-value="1"
                    false-value="0"
                    @on-change="onPublishStatusChange(row, $event)"
                ></i-switch>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    :disabled="loading"
                    :loading="loadingRow"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowView(row)"
                    >详情</Button
                >
                <PoptipButton
                    text="删除"
                    title="是否确认删除？"
                    transfer
                    type="default"
                    style="margin-right: 5px"
                    :loading="loadingRow"
                    :ok="() => onRowDel(row)"
                ></PoptipButton>
                <Dropdown transfer @on-click="onRowMore($event, row)">
                    <Button type="default" size="small"> 更多</Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="action1">action1</DropdownItem>
                        <DropdownItem name="action2">action2</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        >
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showDemoForm"
            :title="actionTitle + 'Demo'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <demo-form
                v-if="modal.showDemoForm"
                :id="curId"
                :formMode="formMode"
            >
            </demo-form>
        </smart-modal>
    </div>
</template>
<script>
import Dict from '_u/dict'
import Enum from '_u/enum'
import { ymdL, capitalize } from '_u/helper'
import { mapCache } from '@/plugins/vux-data-cache'
// Components
import mList from '_v/common/m-list'
import DemoForm from './demo-form'
// 接口
import { numList, numDel } from './demo'

// 枚举
const YN = Enum.get('YN')

export default {
    name: 'demo-list',
    mixins: [mList],
    components: {
        DemoForm,
    },
    data() {
        return {
            loading: false,
            loadingExport: false,
            loadingRow: false,
            mtHeight: 360,
            page: {
                total: 0,
                list: [],
            },
            dict: {
                orgLevel: Dict.NULL, // 发布状态
            },
            modal: {
                showDemoForm: false,
            },
            curId: '',
        }
    },
    computed: {
        ...mapCache({
            filter: 'filter',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'title',
                    title: '标题',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    key: 'orgLevelName',
                    title: '类型',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    key: 'publishStatusText',
                    title: '状态',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'createTimeText',
                    title: '创建时间',
                    align: 'center',
                    width: 150,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        // 列表高度自适应，撑满一屏
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        // 获取列表数据
        fetch() {
            this.loading = true

            return Promise.all([Dict.get(['org_level']), numList(this.filter)])
                .then((args) => {
                    var [dictGroup, list] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.page.list = this.normalizePageData(list.data)
                    this.page.total = parseInt(list.data.page.totalCount)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        normalizePageData(data) {
            var list = data.page.list
            list.forEach((v, i) => {
                // 新增格式化字段
                v.orgLevelName = this.dict.orgLevel.val(v.orgLevel)
                v.publishStatusText = YN.getName(v.publishStatus)
                v.createTimeText = ymdL(v.createTime)
            })
            return list
        },
        // 新增
        onAdd(e) {
            this.formMode = this.FORM_MODE.add
            this.curId = ''
            this.modal.showDemoForm = true
        },
        // 查看详情
        onRowView(row) {
            this.formMode = this.FORM_MODE.view
            this.curId = row.id
            this.modal.showDemoForm = true
        },
        // 点击更多
        onRowMore(name, row) {
            var handler = this['on' + capitalize(name)]

            if (handler) {
                handler.call(this, row)
            }
        },
        // 动作
        onAction1(row) {
            console.log('click 1')
        },
        onAction2(row) {
            console.log('click 2')
        },
        // 删除
        onRowDel(row) {
            this.loadingRow = true

            numDel(row.id)
                .then(() => this.$Message.success('删除成功'))
                .finally(() => (this.loadingRow = false))
        },
        // 导出Excel
        onExport() {
            this.loadingExport = true
            // 查询全部数据并导出
            numList(
                Object.assign({}, this.filter, {
                    pageNo: 1,
                    pageSize: 999999,
                })
            )
                .then((res) => {
                    this.$refs.mt.exportToExcel({
                        rows: this.normalizePageData(res.data),
                    })
                })
                .finally(() => (this.loadingExport = false))
        },
    },
}
</script>
<style lang="less" scoped></style>
